module.exports = __webpack_public_path__ + "static/img/closebtn.80c0c40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/closebtn.png
// module id = qvQx
// module chunks = 1